import React, { useState } from "react";
import { Modal } from "./Modal";

export interface DuplicateModalProps {
	item: { id: string, title?: string, [key: string]: any },
	onDuplicate: (item: any, newId: string) => Promise<any>,
	onClose: () => void,
}

export function DuplicateModal(props: DuplicateModalProps) {
	const { item, onDuplicate, onClose } = props;
	const [dupId, setDupId] = useState(item.id + "-copy");

	return (
		<Modal
			title={"Duplicate: " + (item.title || item.id)}
			saveTitle="Duplicate"
			onCancel={onClose}
			onSave={() => {
				onDuplicate(item, dupId).then(() => {
					onClose();
				});
			}}
		>
			<div className="form-group">
				<label>New ID</label>
				<input
					type="text"
					value={dupId}
					onChange={(e) => setDupId(e.target.value)}
					autoFocus
				/>
			</div>
		</Modal>
	);
}
